import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5a4b9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "global-sidebar--wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("ABOUT")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("TRY IT")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("API PRICING")
const _hoisted_5 = { class: "api-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "api-wrapper__start-now"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["full-height", { hijacking: _ctx.hijackingToken }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["global-sidebar", { hijacking: _ctx.hijackingToken }])
      }, [
        _createElementVNode("nav", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "about",
              replace: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "try-it",
              replace: ""
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "pricing",
              replace: ""
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.checkAccessibleAPIPlan(_ctx.profile.subscription.plan))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn fill t-t-u medium",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModalChangeSubscription && _ctx.showModalChangeSubscription(...args)))
            }, "Start now")
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ], 2))
}